/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './device-manufacurer.reducer';

export const DeviceManufacurerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const deviceManufacurerEntity = useAppSelector(state => state.deviceManufacurer.entity);
  const loading = useAppSelector(state => state.deviceManufacurer.loading);
  const updating = useAppSelector(state => state.deviceManufacurer.updating);
  const updateSuccess = useAppSelector(state => state.deviceManufacurer.updateSuccess);

  const handleClose = () => {
    navigate(`/device-manufacurer${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...deviceManufacurerEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...deviceManufacurerEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.deviceManufacurer.home.createOrEditLabel" data-cy="DeviceManufacurerCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.deviceManufacurer.home.createOrEditLabel">Create or edit a DeviceManufacurer</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-manufacurer-id"
                  label={translate('tinyMedicRestApp.deviceManufacurer.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.code')}
                id="device-manufacurer-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.description')}
                id="device-manufacurer-description"
                name="description"
                data-cy="description"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.name')}
                id="device-manufacurer-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.country')}
                id="device-manufacurer-country"
                name="country"
                data-cy="country"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.address')}
                id="device-manufacurer-address"
                name="address"
                data-cy="address"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.website')}
                id="device-manufacurer-website"
                name="website"
                data-cy="website"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.helpdesk')}
                id="device-manufacurer-helpdesk"
                name="helpdesk"
                data-cy="helpdesk"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.gstCode')}
                id="device-manufacurer-gstCode"
                name="gstCode"
                data-cy="gstCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.regCode')}
                id="device-manufacurer-regCode"
                name="regCode"
                data-cy="regCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.microSec')}
                id="device-manufacurer-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.timestampentry')}
                id="device-manufacurer-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.lastupdated')}
                id="device-manufacurer-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.cursor')}
                id="device-manufacurer-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.deviceManufacurer.active')}
                id="device-manufacurer-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device-manufacurer" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceManufacurerUpdate;
